'use strict';

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var defaultTheme = require('./defaultTheme.js');
var withStyles$1 = require('../../../styles/esm/withStyles/withStyles.js');

function withStyles(stylesOrCreator, options) {
  return withStyles$1(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

module.exports = withStyles;
